import { Role } from 'auth';
import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import ArchiveSwitch from '@/modules/common/components/ArchiveSwitch.tsx';
import { ContractsTab } from '@/modules/admin-dashboard/components/contractManagement/ContractsTab.tsx';
import { PartiesTab } from '@/modules/admin-dashboard/components/contractManagement/PartiesTab.tsx';
import { PageLayout, TabItem, Tabs } from 'ui';

enum ContractManagementTab {
  // Overview = 'Overview',
  Contracts = 'Contracts',
  Parties = 'Parties',
  // Tasks = 'Tasks',
}

const TAB_NAME = 'tab-contract-management';
const PARTY_ID_NAME = 'party_id';

const ContractManagement = () => {
  const [params] = useSearchParams();
  const paramTab = params.get(TAB_NAME);
  const [archive, setArchive] = useState(false);
  const isValidTab =
    paramTab && Object.values(ContractManagementTab).includes(paramTab as ContractManagementTab);
  const [activeTab, setActiveTab] = useState<ContractManagementTab>(
    isValidTab ? (paramTab as ContractManagementTab) : ContractManagementTab.Contracts,
  );

  useEffect(() => {
    if (isValidTab) {
      setActiveTab(paramTab as ContractManagementTab);
    }
  }, [isValidTab, paramTab]);

  useEffect(() => {
    if (!params.get(PARTY_ID_NAME) || activeTab === ContractManagementTab.Parties) return;
    setActiveTab(ContractManagementTab.Parties);
  }, [activeTab, params, setActiveTab]);

  const tabItems = useMemo<TabItem<ContractManagementTab>[]>(
    () => [
      // {
      //   name: ContractManagementTab.Overview,
      //   container: <ContractManagementEmptyTab title="No overview data yet" />,
      // },
      {
        name: ContractManagementTab.Contracts,
        container: <ContractsTab archive={archive} />,
      },
      {
        name: ContractManagementTab.Parties,
        container: <PartiesTab archive={archive} />,
      },
      // {
      //   name: ContractManagementTab.Tasks,
      //   container: <ContractManagementEmptyTab title="No contract tasks yet" />,
      // },
    ],
    [archive],
  );

  return (
    <PageLayout
      headerAction={<ArchiveSwitch active={archive} onChange={setArchive} />}
      title="Contract Management"
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      tabNameParam={TAB_NAME}
      tabs={tabItems}
      contentClassName="px-0 py-0"
    >
      <Tabs items={tabItems} activeTab={activeTab} />
    </PageLayout>
  );
};

export default withPrivateAccess(ContractManagement, Role.COMPLIANCE_ADMIN);
